const SHIPPING_ADDRESS_FORM_VALIDATED_FIELD = 'isValidatedByShippingAddressForm'
const SHIPPING_ADDRESS_FORM_VALIDATION_STATUS_FIELD =
  'shippingAddressFormValidationStatus'
const SHIPPING_ADDRESS_FORM_OPTIONAL_POSTAL_CODE_COUNTRIES = [
  'VN',
  'VIETNAM',
  'VIET NAM',
]

function normalizeCountryCode(country = '') {
  return String(country || '').toUpperCase()
}

function isPostalCodeBlank(postalCode) {
  return postalCode === null || postalCode === undefined || postalCode === ''
}

function wasValidatedByShippingAddressForm(formData = {}) {
  return formData?.[SHIPPING_ADDRESS_FORM_VALIDATED_FIELD] === true
}

function shouldMakeLegacyAddressValidationApiCall(
  formData = {},
  defaultShippingRegion = ''
) {
  const { isToMakeValidationApiCall = false } = formData || {}

  if (wasValidatedByShippingAddressForm(formData)) {
    return false
  }

  return (
    defaultShippingRegion === 'US' ||
    defaultShippingRegion === 'CA' ||
    isToMakeValidationApiCall
  )
}

function isPostalCodeOptionalByShippingAddressForm(formData = {}) {
  const countryCode = normalizeCountryCode(formData?.country)

  return (
    SHIPPING_ADDRESS_FORM_OPTIONAL_POSTAL_CODE_COUNTRIES.includes(
      countryCode
    ) ||
    (wasValidatedByShippingAddressForm(formData) &&
      formData?.[SHIPPING_ADDRESS_FORM_VALIDATION_STATUS_FIELD]?.postalCode
        ?.required === false)
  )
}

function removeShippingAddressFormValidationMeta(formData = {}) {
  if (!wasValidatedByShippingAddressForm(formData)) {
    return formData || {}
  }

  const cleanData = { ...(formData || {}) }
  delete cleanData[SHIPPING_ADDRESS_FORM_VALIDATED_FIELD]
  delete cleanData[SHIPPING_ADDRESS_FORM_VALIDATION_STATUS_FIELD]
  delete cleanData.stateList

  return cleanData
}

function hasNonEmptyObject(value) {
  return (
    !!value &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.keys(value).length > 0
  )
}

function getAddressValidationRequest(formData = {}, reqBody = {}) {
  return removeShippingAddressFormValidationMeta(
    hasNonEmptyObject(reqBody) ? reqBody : formData
  )
}

function getAddressValidationFormData(cleanedFormData = {}, reqBody = {}) {
  return {
    ...cleanedFormData,
    zip: cleanedFormData?.zip || cleanedFormData?.postalCode || '',
    shippingInstructions:
      reqBody?.shippingInstructions ||
      cleanedFormData?.shippingInstructions ||
      '',
    setDefaultAddress:
      cleanedFormData?.setDefaultAddress ?? reqBody?.setDefaultAddress ?? false,
    country: reqBody?.country || cleanedFormData?.country || '',
  }
}

function evaluateAddressValidationResponse(
  response = {},
  formData = {},
  shouldShowRecommendation = () => false
) {
  const recommendationAddress =
    response?.address?.validationDetails?.[0]?.recommendations || []

  if (response?.code === 'ADCOVAL0003') {
    return {
      action: 'invalid_address',
      recommendations: [{ ...formData }, []],
    }
  }

  if (response?.code === 'ONESOURCE_ADPLGIN_VAL_ERROR') {
    return {
      action: 'onesource_error',
      recommendations: [],
    }
  }

  const firstAddress = recommendationAddress?.[0] || {}
  const isFirstRecommendationPresent = Object.keys(firstAddress).length > 0
  const shouldDisplayRecommendations =
    isFirstRecommendationPresent &&
    shouldShowRecommendation(formData, firstAddress)

  return {
    action: shouldDisplayRecommendations ? 'show_recommendations' : 'continue',
    recommendations: [{ ...formData }, ...recommendationAddress],
  }
}

export {
  SHIPPING_ADDRESS_FORM_VALIDATED_FIELD,
  SHIPPING_ADDRESS_FORM_VALIDATION_STATUS_FIELD,
  evaluateAddressValidationResponse,
  getAddressValidationFormData,
  getAddressValidationRequest,
  isPostalCodeBlank,
  isPostalCodeOptionalByShippingAddressForm,
  removeShippingAddressFormValidationMeta,
  shouldMakeLegacyAddressValidationApiCall,
  wasValidatedByShippingAddressForm,
}
